// @flow weak

import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import { clamp } from 'app/common/CommonUtils';

const ProgressPercent = ({ formattedPercent }) => (
  <span>{formattedPercent}</span>
);

const Progress = createReactClass({
  displayName: 'Progress',
  mixins: [PureRenderMixin],

  propTypes: {
    max: PropTypes.number.isRequired,
    Renderer: PropTypes.func.isRequired,
    type: PropTypes.oneOf([
      'auto',
      'primary',
      'safe',
      'warning',
      'danger',
      'running',
    ]).isRequired,
    value: PropTypes.number.isRequired,
  },

  getDefaultProps() {
    return {
      max: 1,
      Renderer: ProgressPercent,
      type: 'auto',
    };
  },

  computeDecimal() {
    const { max, value } = this.props;
    return clamp(0, 1, value / max);
  },

  computeType() {
    const { type } = this.props;
    const decimal = this.computeDecimal();
    if (type !== 'auto') {
      return type;
    }
    if (decimal >= 0.8) {
      return 'danger';
    }
    if (decimal >= 0.5) {
      return 'warning';
    }
    return 'safe';
  },

  render() {
    const decimal = this.computeDecimal();
    const { Renderer } = this.props;
    return (
      <Renderer
        {...this.props}
        decimal={decimal}
        formattedPercent={`${(100 * decimal).toFixed(2)}%`}
        type={this.computeType()}
      />
    );
  },
});

export default Progress;
